import React, { useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import OKomBreadcrumb from '../Components/OsloKommuneUI/OKomBreadcrumb';
import OKomTab from '../Components/OsloKommuneUI/OKomTab';
import OKomLoading from '../Components/OsloKommuneUI/OKomLoading';
import RegistrationPeriodSection from '../Components/RegistrationPeriodSection';
import AthleticsRegistrationConfigView from './AthleticsRegistrationConfigView';

const TAB_PERIOD = 'Påmeldingsperioder';
const TAB_EVENTS = 'Øvelsesmatrise';
// OKomTab defaults to the first tab, so Påmeldingsperioder is the default.
const TABS = [TAB_PERIOD, TAB_EVENTS];

const AthleticsConfigView: React.FC<RouteComponentProps> = () => {
  const [activeTab, setActiveTab] = useState<string>(TAB_PERIOD);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = 'Konfigurasjon — Friidrett';
  }, []);

  return (
    <>
      <OKomBreadcrumb path='Konfigurasjon, Friidrett'></OKomBreadcrumb>
      {loading && <OKomLoading text="Laster..." />}
      <div className="ods-grid ods-grid--center ods-margin-top-11">
        <div className="ods-grid__column--12 ods-text--align-center">
          <OKomTab tabs={TABS} onTabChange={setActiveTab} />
        </div>
      </div>
      <div className="ods-padding-top-3">
        {activeTab === TAB_PERIOD && <RegistrationPeriodSection eventType="athletics" onLoadingChange={setLoading} />}
        {activeTab === TAB_EVENTS && <AthleticsRegistrationConfigView embedded onLoadingChange={setLoading} />}
      </div>
    </>
  );
};

export default withRouter(AthleticsConfigView);
